module.exports = __webpack_public_path__ + "img/Adonai Garcia.8cbb2533.jpg";